import { render } from "./SaberWeightsContent.vue?vue&type=template&id=0016f2e6&ts=true"
import script from "./SaberWeightsContent.vue?vue&type=script&lang=ts"
export * from "./SaberWeightsContent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__